import { render, staticRenderFns } from "./BlockType16.vue?vue&type=template&id=5ef2de90&scoped=true"
import script from "./BlockType16.vue?vue&type=script&lang=ts"
export * from "./BlockType16.vue?vue&type=script&lang=ts"
import style0 from "./BlockType16.vue?vue&type=style&index=0&id=5ef2de90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2de90",
  null
  
)

export default component.exports